module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line",
    class: {
      'wide': _vm.wide && _vm.wide === true, 'align-center': _vm.alignCenter
    }
  }, [_c('div', {
    staticClass: "line__title"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _vm._t("newline")], 2), _vm._v(" "), (_vm.value && _vm.value !== null) ? _c('div', {
    staticClass: "line__value type",
    class: 'type-' + _vm.type
  }, [(_vm.value === false) ? _c('span', [_vm._v("Nej")]) : _vm._e(), _vm._v(" "), (_vm.value === true) ? _c('span', [_vm._v("Ja")]) : _vm._e(), _vm._v(" "), (_vm.value !== true && _vm.value !== false && _vm.value !== 'donotshow') ? _c('span', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.value)
    }
  }), _vm._v(" "), (_vm.suffix) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.suffix)
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._t("extra")], 2) : _c('div', {
    staticClass: "line__value"
  }, [_vm._v("\n        -\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-732aedac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/line-data.vue
// module id = 354
// module chunks = 1